<template>
  <div>
    <filters-component v-model="filters" />
    <crud-component v-if="uiSchema" collection="document" :ui-schema="uiSchema" :filters="filters">
      <template slot="custom-test" slot-scope="value">
        {{value}}
      </template>
    </crud-component>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config.js'
import CrudComponent from '../components/CrudComponent.vue'
import FiltersComponent from '../components/FiltersComponent.vue'

export default {
  name: "admin",
  components: {
    CrudComponent,
    FiltersComponent,
  },
  data: function() {
    return {
      filters: {},
      uiSchema: null,
    }
  },
  async created() {
    this.uiSchema = {
      "$..__v": { "x-style": { "display": "none" } },
      "$.._id": { "x-style": { "display": "none" } },
      "$..documents.items.properties._id": {
        "x-style": { "display": "block" },
        "x-display": "custom-qrcode",
      },
      "$..documents.items.properties.name": { "x-cols": 6 },
      "$..documents.items.properties.type": {
        "x-cols": 3,
        "x-display": "custom-combobox",
        "x-props": { "items": (await axios.get(`${config.apiUrl}/document?p=type`)).data }
      },
      "$..documents.items.properties.lieu": {
        "x-cols": 3,
        "x-display": "custom-combobox",
        "x-props": { "items": (await axios.get(`${config.apiUrl}/document?p=lieu`)).data }
      },
      "$..documents..history.items.properties.*": { "x-cols": 4 },
    }
  }
}
</script>
<style scoped>
</style>
